module.exports = __webpack_public_path__ + "bs.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/bs.svg
// module id = 720
// module chunks = 0